import { useEffect, useState } from 'react'
import { InstructorProfileData, ProfileReview } from '../../server/types'
import './style.scss'
import { instructorReviewConnector } from '../../server/connector/instructorReviewConnector'
import { instructorStateData } from '../../data/instructorStateData'
import { useAppDispatch } from '../../redux/hooks'
import { setReview1StarCount, setReview2StarCount, setReview3StarCount, setReview4StarCount, setReview5StarCount, setReviewCount } from '../../redux/reducers/instructorSlice'

interface InstructorProfileReviewsProps {
	profileData: InstructorProfileData
}

function InstructorProfileReviews({profileData}: InstructorProfileReviewsProps) {
	const [reviewsRequestCompleted, setReviewsRequestCompleted] = useState<boolean>(false)
	const [reviews, setReviews] = useState<ProfileReview[] | undefined>(undefined)

	const dispatch = useAppDispatch()

	useEffect(() => {
		// console.log(`Loading reviews for ${profileData.id}`)
		requestReviews()
	}, [])

	const requestReviews = () => {
		if (instructorReviewConnector.requestInProgress) {
			console.log('[InstructorProfileReviews] - requestReviews() called while requestInProgress')
		} else {
			instructorReviewConnector.performGetReviewsRequest(profileData.id).then((successRequest) => {
				// dispatch(searchDataUpdated())
				setReviews(instructorStateData.reviews)
				setReviewsRequestCompleted(true)
				dispatch(setReviewCount(instructorStateData.reviews.length))
				let reviewCounts: number[] = [0, 0, 0, 0, 0]
				instructorStateData.reviews.forEach((review: ProfileReview) => {
					reviewCounts[Math.round(review.rating) - 1] += 1
				})
				dispatch(setReview1StarCount(reviewCounts[0]))
				dispatch(setReview2StarCount(reviewCounts[1]))
				dispatch(setReview3StarCount(reviewCounts[2]))
				dispatch(setReview4StarCount(reviewCounts[3]))
				dispatch(setReview5StarCount(reviewCounts[4]))
				if (!successRequest) {
					console.log('WARNING - [App] - performSearchRequest() failed')
				}
			})
		}
	}

	return (
		<div className='section-content'>
			{ reviewsRequestCompleted && 
				<div className='instructor-profile-review-section'>
					<div className='instructor-profile-review-title'>Reviews</div>
					<div className='instructor-profile-review-card-wrap'>
						{
							reviews && reviews.length > 0 ? (
								reviews.map((review: ProfileReview, reviewIndex: number) => 
									<div 
										className='instructor-profile-review-card'
										key={`instructorReviewCard${reviewIndex}`}
									>
										<div className='instructor-profile-review-card-text'>{review.review}</div>
										<div className='instructor-profile-review-card-profile-wrap'>
											<div className='instructor-profile-review-card-profile-inner-wrap'>
												<div className='instructor-profile-review-card-profile-image-wrap'>
													<img 
														className='instructor-profile-review-card-profile-image'
														src={review.iconUrl}
														alt='User profile'
														key={`userProfileImg${reviewIndex}`}
													/>
												</div>
												<div className='instructor-profile-review-card-rating-wrap'>
													<div className='instructor-profile-review-card-rating-star-wrap'>
														{
															[...Array(5)].map((_, index) => 
															<img 
																className='instructor-profile-review-card-rating-star-image'
																key={`reviewStar${reviewIndex}-${index}`}
																src={review.rating > index ? '/imgs/icons/icon-star.svg' : '/imgs/icons/icon-star-empty.svg'}
																alt='star'
															/>
														)
														}
													</div>
													{/* <div className='instructor-profile-review-card-rating-name'>{review.name}</div> */}
												</div>
											</div>
											<div className='instructor-profile-review-card-rating-name'>{review.name}</div>
										</div>
									</div>
								)
							) : <div className='instructor-profile-review-loading'>No Reviews for this instructor</div>
						}
					</div>
				</div>
			}
		</div>
	)
}

export default InstructorProfileReviews


/*
<div className='instructor-profile-review-card'>
						<div className='instructor-profile-review-card-text'>
							Really helpful instructor, would recommend to a friend.
						</div>
						<div className='instructor-profile-review-card-profile-wrap'>
							<div className='instructor-profile-review-card-profile-image-wrap'></div>
							<div className='instructor-profile-review-card-rating-wrap'>
								<div className='instructor-profile-review-card-rating-star-wrap'>
									{
										[...Array(5)].map((_, index) => 
										<div 
											className='instructor-profile-rating-card-list-bar-wrap'
											key={`RatingBar${index}`}
										>
											<div className='instructor-profile-rating-card-list-bar-number'>{5 - index}</div>
											<div className='instructor-profile-rating-card-list-bar-blank'>
												<div 
													className='instructor-profile-rating-card-list-bar-colour'
													style={{width: `${Math.random() * 100}%`}}
												/>
											</div>
										</div>
									)
									}
								</div>
								<div className='instructor-profile-review-card-rating-name'></div>
							</div>
						</div>
					</div>
*/

/*
console.log('TEMP - Delaying for a few moments before adding test reviews')
// TODO: add functionality to get reviews for the profile
setTimeout(() => {
	setReviews([
		{
			review: 'Really helpful instructor, would recommend to a friend.',
			rating: 5,
			name: 'Mina',
			iconUrl: '/imgs/temp/profile_thumbnails/profile-review-001.png'
		},{
			review: 'Didnt like the language used, will not be using instructor again.',
			rating: 1,
			name: 'Karen',
			iconUrl: '/imgs/temp/profile_thumbnails/profile-review-001.png'
		},{
			review: 'Great instructor—super helpful, encouraging, and made learning fun.',
			rating: 4,
			name: 'Carly',
			iconUrl: '/imgs/temp/profile_thumbnails/profile-review-001.png'
		},{
			review: 'Great analysis, 5/5 stars from me.',
			rating: 5,
			name: 'Steve',
			iconUrl: '/imgs/temp/profile_thumbnails/profile-review-001.png'
		}
	])
}, 3000)
*/